import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from '../../Landing/theme-provider';
import Navigation from '../components/Navigation';
import LifetimeCTA from '../components/LifetimeCTA';
import ComprehensiveFAQ from '../components/ComprehensiveFAQ';
import Testimonials from '../../Lander/components/Testimonials/Testimonials';
import Footer from '../../Landing/footer';

const Page = styled.div`min-height:100vh;background:linear-gradient(180deg, #f3efff 0%, #ffffff 600px);color:#0b0f1a;`;
const Main = styled.main`
  margin-top: -70px;
  @media (max-width: 968px) {
    margin-top: -72px;
  }
`;
const Hero = styled.section`
  padding: 150px 24px 70px;
  text-align: center;
  background: linear-gradient(180deg, #f3efff 0%, #fff 100%);
  h1{max-width:44.2rem;margin:14px auto;font-family:"Space Grotesk",sans-serif;font-weight:700;font-size:clamp(2.6rem,7vw,4rem);line-height:.94;letter-spacing:-.04em;color:#0f1116;text-wrap:balance;}
  p{max-width:680px;margin:0 auto;color:#5f5a70;font-size:18px;line-height:1.7;}
  span{font-size:12px;font-weight:800;letter-spacing:.16em;color:#6d4aff;}
`;

const LaunchDealPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
      <Page>
        <Helmet>
          <title>SmushChat Founders Edition Launch Deal | SmushLabs</title>
          <meta name="description" content="Review the SmushChat Founders Edition one-time purchase, included limits, and refund window." />
          <link rel="canonical" href="https://smushlabs.ai/launch-deal" />
        </Helmet>
        <Navigation />
        <Main>
          <Hero><span>FOUNDERS EDITION</span><h1>A one-time SmushChat plan for early customers</h1><p>Pay once. Spend less time answering déjà vu while SmushChat handles the questions that keep coming back.</p></Hero>
          <LifetimeCTA />
          <ComprehensiveFAQ />
          <Testimonials />
        </Main>
        <Footer />
      </Page>
    </ThemeProvider>
  );
};

export default LaunchDealPage;
